export default {
  // Main navigation sections
  products: 'المنتجات',
  support: 'الدعم',
  resources: 'الموارد',

  // Product links
  carInsurance: 'تأمين السيارات',
  healthInsurance: 'التأمين الطبي',
  medicalMalpractice: 'تأمين ضد الأخطاء الطبية',
  travel: 'تأمين السفر',
  fleet: 'تأمين الأسطول',
  protectionAndSaving: 'الحماية والادخار',
  marine: 'نقل البضائع',
  civilLiability: 'تأمين المسؤولية المدنية',
  // Support links
  contactUs: 'تواصل معنا',
  privacyPolicy: 'سياسة الخصوصية',
  termsAndConditions: 'الشروط والأحكام',
  helpCenter: 'مركز المساعدة',

  // Resource links
  thirdPartyInsurance: 'تأمين ضد الغير',
  comprehensiveInsurance: 'تأمين شامل',
  vehicleHistoryCheck: 'معلومات المركبة من موجز',
  smartPackage: 'الباقة الذكية',
  tameeniHero: 'تأميني هيرو',
  tameeniOffers: 'خصومات وعروض تأميني',
  policyUploadStatus: 'استعلام حالة الرفع (المرور/نجم)',
  qitafEarnRedeem: 'كسب واستبدال قطاف',
  faq: 'الأسئلة الشائعة',
  blog: ' مدونة تأميني',

  // Health insurance sub-items
  health_individual: 'تأمين صحي للأفراد',
  health_sme: '  تأمين الصحي للمنشآت ',

  // Health insurance sub-sections
  forBusiness: 'للشركات',
  forIndividual: 'للأفراد',
  smeHealth: 'التأمين الصحي للمنشآت',
  smeDescription: 'التأمين الصحي للمنشآت بعدد أعضاء أقل من 250',
  premiumResidency: 'تأمين الإقامة المميزة',
  premiumResidencyDescription: 'التأمين الصحي لك وعائلتك',
  domesticHelper: '  تأمين العمالة المنزلية',
  domesticHelperDescription: 'التأمين الصحي والعقدي',

  // Social media links
  facebook: 'فيسبوك',
  x: 'إكس',
  instagram: 'إنستغرام',
  youtube: 'يوتيوب',
  snapchat: 'سناب شات',
  whatsapp: 'واتساب',

  // Legacy translations (keeping for backward compatibility)
  insuranceAuthority: 'لوائح هيئة التأمين',
  partners: 'شركاؤنا',
  contactus: 'تواصل معنا',
  privacy: 'سياسة الخصوصية',
  terms: 'الشروط والأحكام',
  third_party_insurance: 'تأمين ضد الغير',
  comprehensive_insurance: 'تأمين شامل',
  vehicle_history_check: 'معلومات المركبة من موجز',
  smart_package: 'الباقة الذكية',
  tameeni_offers: 'خصومات و عروض تأميني',
  medical_malpractice: 'الأخطاء الطبية',
  home: 'تأمين المنزل',
  careers: 'الوظائف',
  copyRightsText:
    '© تأميني 2025. جميع الحقوق محفوظة شركة تأميني لوساطة التأمين الالكتروني شركة شخص واحد',
  downloadTameeniApp: 'حمل تطبيق تأميني الآن',
  followTameeni: 'تابع تأميني',
  poweredBy: 'تطوير وتشغيل',
} as const
